import { Component, OnInit } from '@angular/core';
import { Contract, Data } from '@mlc/types';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { of, switchMap } from 'rxjs';
import { ManagerInsights } from 'src/app/core/models/managerInsight.model';
import { ContractService } from 'src/app/core/services/wallet/wallet.service';

@UntilDestroy()
@Component({
    selector: 'app-manager-insight',
    templateUrl: './manager-insight.component.html',
    styleUrls: ['./manager-insight.component.scss'],
    standalone: false
})
export class ManagerInsightComponent  implements OnInit {

  public managerInsight!: ManagerInsights | undefined;
  public busy: boolean = true;

  constructor(private contractService: ContractService) {}

  ngOnInit() {
    this.contractService.get().pipe(
      untilDestroyed(this),
      switchMap((contract: Data<Contract> | undefined) => {
        this.busy = true;
        const productId: number | undefined = contract?.attributes?.product?.data?.id;
        if (!productId) {
          return of(undefined);
        }
        return this.contractService.getCurrentManagerInsight(productId);
      })
    ).subscribe((managerInsight: ManagerInsights | undefined) => {
      this.managerInsight = managerInsight;
      this.busy = false;
    });
  }
}
